<template>
  <div id="app">
    <el-row>
      <el-col
        :xs="24"
        :sm="{ span: 20, offset: 2 }"
        :lg="{ span: 18, offset: 3 }"
      >
        <div class="grid-content bg-purple">
          <!-- <Index /> -->
          <router-view></router-view>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  // name: 'app',
}
</script>

<style>
body,
html {
  font-family: 'Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  font-weight: 400;
  padding: 0%;
  margin: 0%;
}
.bg-purple {
  background: #d3dce6;
}
.grid-content {
  min-height: 36px;
}
</style>
